import { c as _c } from "react/compiler-runtime";
import { AccountStatus } from '@newfront-insurance/account-api';
import { Alert, Badge, Box, CircleSpinnerInline, DefinitionList, FeaturedCard } from '@newfront-insurance/core-ui';
import { useContext, type JSX } from 'react';
import type { SearchResultRouting } from '../../../../../../bff/types';
import { useAccountByUuid } from '../../../../../hooks/use-account-by-uuid';
import { useServicingTeamForAccount } from '../../../../../hooks/use-servicing-team-for-account';
import { bugsMessage } from '../../../../../utils';
import { SearchContext } from '../../../context';
import { useItemResultRouting } from '../../../hooks/use-item-result-routing';
import { LoadingWrapper } from '../loading-wrapper';
import { ServicingTeam } from '../servicing-team';
interface Props {
  accountUuid: string;
  hasViewAccess: boolean;
  routing: SearchResultRouting;
  containerId?: string;
}
export function AccountCardPreview(t0) {
  const $ = _c(29);
  const {
    accountUuid,
    hasViewAccess,
    routing,
    containerId
  } = t0;
  const t1 = !hasViewAccess;
  let t2;
  if ($[0] !== accountUuid || $[1] !== t1) {
    t2 = {
      accountUuid,
      isPublic: t1
    };
    $[0] = accountUuid;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: account,
    error
  } = useAccountByUuid(t2);
  const {
    getServicingTeamForAccount
  } = useServicingTeamForAccount();
  const {
    goToItemResultPage
  } = useItemResultRouting();
  const {
    setIsSearchActive
  } = useContext(SearchContext);
  if (error) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Box width={512}><Alert>{bugsMessage("Something went wrong trying to loading the account")}</Alert></Box>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (!account) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <LoadingWrapper><CircleSpinnerInline /></LoadingWrapper>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== account || $[6] !== getServicingTeamForAccount) {
    t3 = getServicingTeamForAccount(account);
    $[5] = account;
    $[6] = getServicingTeamForAccount;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const servicingTeam = t3;
  const isArchived = account.status.status === AccountStatus.ARCHIVED;
  let t4;
  if ($[8] !== goToItemResultPage || $[9] !== routing || $[10] !== setIsSearchActive) {
    t4 = async e => {
      e.preventDefault();
      setIsSearchActive(false);
      await goToItemResultPage(routing);
    };
    $[8] = goToItemResultPage;
    $[9] = routing;
    $[10] = setIsSearchActive;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = "details" in account ? account.details.dba : account.dba;
  let t6;
  if ($[12] !== isArchived) {
    t6 = isArchived ? <Badge>Archived</Badge> : null;
    $[12] = isArchived;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== account.definitionListItems) {
    t7 = account.definitionListItems.length > 0 && <DefinitionList items={account.definitionListItems} />;
    $[14] = account.definitionListItems;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== containerId || $[17] !== servicingTeam) {
    t8 = servicingTeam.length > 0 && <ServicingTeam servicingTeam={servicingTeam} containerId={containerId} />;
    $[16] = containerId;
    $[17] = servicingTeam;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== account.name || $[23] !== routing.absolute || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t9) {
    t10 = <Box backgroundColor="#fff" borderRadius={6} width={512}><FeaturedCard eyebrow="Account" title={account.name} href={routing.absolute} onClick={t4} subtitle={t5} badge={t6} content={t9} /></Box>;
    $[22] = account.name;
    $[23] = routing.absolute;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}